<template>
  <ContentSection>
    <Container>
      <!-- TITLE -->
      <h2
        v-if="data.heading"
        class="default-component-title mb-8 sm:mb-10"
        v-html="$replaceHtmlTags(data.heading)"
      />

      <AnimatedContainer>
        <!-- GRID -->
        <ul
          class="grid w-full auto-rows-fr grid-cols-1 gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4"
        >
          <li
            v-for="entry in data.entries"
            :key="entry.slug"
            class="slide-in-left"
          >
            <EntryCard
              class="min-h-[21rem] w-full sm:min-h-[27rem] 3xl:min-h-[32rem]"
              :data="entry"
            />
          </li>
        </ul>
      </AnimatedContainer>
    </Container>
  </ContentSection>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>
